/* Wild Gainz buy box. Was inline in sections/wildgainz-legend-buybox.liquid,
   where it was re-sent and re-parsed with every HTML response and never
   cached. It carries no Liquid: the section's per-instance data lives in the
   adjacent <script type="application/json" id="wg-data-{section id}">, and
   initBuybox reads its own id off the DOM, so the file is shared by every
   instance and every page. */
(function(){
  /* Web component: the browser runs connectedCallback every time the element
     is inserted into the DOM, including every theme-editor re-render, so the
     buy box re-initializes itself with no event listening or id matching.
     initBuybox reads its own id and co-located JSON, so it is self-contained
     and safe with multiple instances on one page. */
  /* Self-heal: the ADMIN theme editor updates the preview per keystroke by
     MORPHING the section's DOM in place. The element is never disconnected,
     so no lifecycle callback fires, while the JS-built children are wiped
     and attributes are synced to the server HTML (removing data-wg-booted).
     This observer notices that state and re-initializes. Attached once per
     element instance; a replaced element gets a fresh one via
     connectedCallback. */
  function watchHealth(root){
    if(root.__wgWatched) return;
    root.__wgWatched = true;
    let scheduled = false;
    const check = () => {
      scheduled = false;
      if(!root.isConnected) return;
      const wiped = !root.dataset.wgBooted || (root.__wgHasRows && !root.querySelector('.wg-mcard'));
      if(!wiped) return;
      delete root.dataset.wgBooted;
      initBuybox(root);
    };
    const mo = new MutationObserver(() => {
      if(scheduled) return;
      scheduled = true;
      requestAnimationFrame(check);
    });
    mo.observe(root, {attributes:true, childList:true, subtree:true});
  }

  /* Failure-safe entry: the editor applies a re-render across more than one
     mutation batch, so the healer can run against a HALF-BUILT section. If
     init throws (or the data block is not there yet), the boot flag must be
     cleared again or the watcher would treat the blank section as healthy
     forever. Failed inits retry on the next mutation and on a short timer,
     capped so a truly broken state cannot loop. */
  function initBuybox(root){
    if(!root || root.dataset.wgBooted) return;
    root.dataset.wgBooted = '1';
    root.classList.add('wg-js'); /* JS alive: show app UI, hide the no-JS fallback */
    root.__wgHasRows = false;
    watchHealth(root);
    try{
      initBuyboxInner(root);
      root.__wgTries = 0;
    }catch(err){
      delete root.dataset.wgBooted;
      root.__wgTries = (root.__wgTries||0)+1;
      try{ if(window.Shopify&&Shopify.designMode) console.warn('[wg-buybox] init failed (attempt '+root.__wgTries+'), retrying:', err); }catch(e){}
      if(root.__wgTries<10 && !root.__wgRetry){
        root.__wgRetry = setTimeout(()=>{ root.__wgRetry=null; initBuybox(root); },300);
      }
    }
  }

  function initBuyboxInner(root){
  const sid = root.id.replace(/^wg-buybox-/,'');
  const dataEl = document.getElementById('wg-data-'+sid);
  if(!dataEl) throw new Error('data block wg-data-'+sid+' not in DOM yet');
  const DATA = JSON.parse(dataEl.textContent);
  const TXT = DATA.txt || {};
  /* drop blocks with no product assigned so nulls can't crash the UI */
  DATA.flavors = DATA.flavors.filter(f=>f.variantId && !f.hidden);
  if(!DATA.flavors.length){
    if(DATA.designMode){
      /* theme editor: a freshly added section must show something, not vanish */
      root.querySelector('.wg-inner').innerHTML='<p style="padding:48px 16px;text-align:center;font-weight:700">WG Legend Buy Box: assign a product to each Flavor block to build this section.</p>';
    }else{
      root.style.display='none';
    }
    return;
  }

  /* ---------- money ---------- */
  function money(cents){
    const amt=(cents/100).toFixed(2);
    const fmt=DATA.moneyFormat||'';
    if(fmt){
      const out=fmt.replace(/\{\{[^}]*\}\}/g, amt).replace(/<[^>]+>/g,'').trim();
      if(out) return out;
    }
    return '$'+amt;
  }

  /* ---------- selling plan resolution ----------
     Priority: explicit plan ID from settings → name match on "1 month"/"2 month". */
  function planFor(flavor, months){
    /* plan = delivery interval only. quantity (solo/partner) is a separate line-item qty,
       read live by the Loop discount flow. one plan serves both household modes. */
    const explicit = DATA.planIds[String(months)];
    if(explicit){
      const hit = flavor.plans.find(p=>String(p.planId)===String(explicit));
      if(hit) return hit;
    }
    const mRx = new RegExp('\\b'+months+'\\s*month','i');
    return flavor.plans.find(p=>mRx.test(p.planName)) || null;
  }

  /* ---------- configured tiers (Seal + Bundler era) ----------
     Bundler discounts by TOTAL quantity in the order, mix-and-match across
     products. These percents are display mirrors of the Bundler rules;
     the real discount is applied at checkout. */
  function subPct(bags){
    const k=Math.min(Math.max(bags,1),5);
    return DATA.subPcts[String(k)]||0;
  }

  /* per-bag subscription price in selling-plan mode = the REAL allocation */
  function bag1Cents(flavor, months){
    const p = planFor(flavor, months);
    return p ? p.priceCents : flavor.priceCents;
  }

  /* ---------- state ---------- */
  /* On a flavor's own product page that flavor leads, so the heading and the
     card underneath it agree. Falls through to the first AVAILABLE flavor, so
     a front-end sold-out first block does not become the silent default for
     gallery and pricing. The matching card is also marked active in Liquid;
     this keeps the two in step once scripts take over. */
  function pageFlavor(){
    if(!DATA.pageProductId) return null;
    return DATA.flavors.find(f=>f.productId===DATA.pageProductId) || null;
  }
  const leadFlavor = pageFlavor() || DATA.flavors.find(f=>f.available) || DATA.flavors[0];
  const state = { household:'solo', months:2, counts:{}, rows:[], plan:'sub', galleryFlavor:leadFlavor.id, pickedFlavor:null };

  DATA.flavors.forEach(f=>state.counts[f.id]=0);
  const mult = ()=> state.household==='couple'?2:1;
  const capBags = ()=> state.months*mult();
  const chosen = ()=> Object.values(state.counts).reduce((a,b)=>a+b,0);
  const effMonths = ()=> state.months;
  const flavorById = id => DATA.flavors.find(f=>f.id===id);

  /* ---------- render ---------- */
  function q(sel){ return root.querySelector(sel); }
  function qa(sel){ return root.querySelectorAll(sel); }

  function render(){
    qa('#wg-house-'+sid+' button').forEach(b=>b.classList.toggle('active',b.dataset.h===state.household));
    q('#wg-nudge-'+sid).classList.toggle('show',state.household==='solo'&&state.months===1);

    const m=mult(), cap=capBags(), got=chosen();
    const galleryF=flavorById(state.galleryFlavor)||DATA.flavors[0];
    const fullCents=galleryF.priceCents;

    /* the discount tier for a size, honest in both price modes: configured
       reads the Bundler tier for the bag count, selling-plan reads the
       allocation discount for the interval */
    function tierPct(mm,hmult){
      if(DATA.priceSource==='configured') return subPct(mm*hmult);
      return fullCents>0?Math.max(0,Math.round((1-bag1Cents(galleryF,mm)/fullCents)*100)):0;
    }

    qa('.wg-size').forEach(s=>{
      const mm=+s.dataset.months, b=mm*m;
      s.classList.toggle('active',mm===state.months);
      s.setAttribute('aria-pressed',mm===state.months?'true':'false');
      s.querySelector('[data-bags]').textContent = b+' bag'+(b>1?'s':'');
      const ship=s.querySelector('[data-ship]');
      if(b>=DATA.freeShipQty){ship.textContent='+ Free shipping';ship.className='wg-ship free';}
      else{ship.textContent='+'+DATA.shipText+' shipping';ship.className='wg-ship paid';}
      const disc=s.querySelector('[data-size-disc]');
      /* subscription tiers only: hidden at 0 and while one-time is selected */
      if(disc){ const p=tierPct(mm,m); disc.textContent=TXT.sizeDisc.replace('[pct]',p); disc.hidden=p<=0||state.plan!=='sub'; }
      const cad=s.querySelector('[data-cadence]');
      if(cad){ cad.textContent = state.plan==='sub' ? (mm===1?TXT.cadSingle:TXT.cadMulti.replace('[months]',mm)) : ''; }
    });

    /* progress bar: one segment per bag in the cap, filled as bags are picked.
       Segments are rebuilt only when the cap changes so each fill animates. */
    const prompt=q('#wg-prompt-'+sid), left=cap-got, done=left<=0;
    prompt.classList.toggle('done',done);
    let hint;
    if(got===0) hint=esc(TXT.promptEmpty||'').replace('[cap]','<b>'+cap+' bag'+(cap>1?'s':'')+'</b>');
    else if(!done) hint=esc(TXT.mixLeft||'').replace('[left]','<b>'+left+'</b>');
    else hint=esc(TXT.mixDone||'').replace('[cap]',cap);
    const count=(done?'✓ ':'')+esc(TXT.mixCount||'').replace('[got]','<b>'+got+'</b>').replace('[cap]',cap).replace('[bags]',cap>1?'bags':'bag');
    let track=prompt.querySelector('.wg-mixbar__track');
    if(!track||track.children.length!==cap){
      let segs=''; for(let i=0;i<cap;i++) segs+='<span class="wg-mixbar__seg"></span>';
      prompt.innerHTML='<div class="wg-mixbar__row"><span class="wg-mixbar__count" data-mixcount></span><span class="wg-mixbar__hint" data-mixhint></span></div>'
        +'<div class="wg-mixbar__track" role="progressbar" aria-valuemin="0" aria-valuemax="'+cap+'" aria-valuenow="0">'+segs+'</div>';
      track=prompt.querySelector('.wg-mixbar__track');
    }
    prompt.querySelector('[data-mixcount]').innerHTML=count;
    prompt.querySelector('[data-mixhint]').innerHTML=hint;
    track.setAttribute('aria-valuenow',got);
    track.setAttribute('aria-valuetext',(count+' '+hint).replace(/<[^>]+>/g,''));
    Array.prototype.forEach.call(track.children,(s,i)=>s.classList.toggle('on',i<got));
    syncCards();

    const fm=effMonths();

    const nb=cap;
    /* price the ACTUAL mix: chosen bags at each flavor's own price; any
       unpicked remainder is projected at the gallery flavor's price so a
       total shows before the mix is complete. Identical to the old single
       flavor math while both products share one price, but stays honest if
       the two product prices ever diverge. */
    let fullSum=0, allocSum=0;
    /* every bag in the order, so the total can be built a bag at a time */
    const bags=[];
    DATA.flavors.forEach(f=>{
      const c=state.counts[f.id]||0;
      if(!c) return;
      fullSum+=f.priceCents*c;
      allocSum+=bag1Cents(f, fm)*c;
      bags.push({unit:f.priceCents, count:c});
    });
    const rem=nb-got;
    if(rem>0){ fullSum+=fullCents*rem; allocSum+=bag1Cents(galleryF, fm)*rem; bags.push({unit:fullCents, count:rem}); }

    /* subscription total for this order.
       configured mode: a bag at a time, each at the tier the order reaches,
       so this total and the drawer's are built the same way and agree to the
       cent, and both agree with the till. See discountedUnit() below.
       selling-plan mode: the allocation prices, checkout truth under Loop. */
    let subTotal, startPct;
    if(DATA.priceSource==='configured'){
      startPct=subPct(nb);
      subTotal=bags.reduce((n,b)=>n+discountedUnit(b.unit, nb)*b.count, 0);
    }else{
      subTotal=allocSum;
      startPct=fullSum>0?Math.max(0, Math.round((1 - subTotal/fullSum)*100)):0;
    }

    /* hide the discount pill and strikethrough when there is no saving to show;
       the strikethrough is the order's full-price total, like for like with
       the discounted total under it */
    const ribbon=q('[data-subribbon]');
    if(ribbon){ ribbon.textContent=startPct+'% OFF'; ribbon.hidden=startPct<=0; }
    q('[data-subwas]').textContent=money(fullSum);
    q('[data-subwas]').style.display=startPct>0?'':'none';
    q('[data-subbag]').textContent=money(subTotal)+(DATA.isAU?' AUD':'');
    q('[data-subserving]').textContent=money(Math.round(subTotal/(nb*DATA.servings)))+' / day';
    const saveEl=q('[data-subsave]');
    if(saveEl){
      const diff=fullSum-subTotal;
      saveEl.textContent=String(TXT.subSave||'You save [amount]').replace('[amount]',money(diff));
      saveEl.hidden=!(diff>0);
    }

    /* top live price */
    const isSub=state.plan==='sub';
    const nowTotal=isSub?subTotal:fullSum;
    const hasSave=isSub&&fullSum>subTotal;
    q('[data-topwas]').style.display=hasSave?'':'none';
    q('[data-topwas]').textContent=money(fullSum);
    q('[data-topnow]').textContent=money(nowTotal)+(DATA.isAU?' AUD':'');
    q('[data-topsave]').style.display=hasSave?'':'none';
    q('[data-topsave]').textContent='Save '+money(fullSum-subTotal);

    /* order summary */
    /* Months of supply, not a serving count. "6 bags · 3-month supply" answers
       how long this lasts; "180 servings" makes the reader do the division. The
       months are the size chosen, so doubling up raises the bags and leaves the
       duration alone, which is the whole point of that choice. */
    const supplyText = String(TXT.supply || '[months]-month supply').replace('[months]', state.months);
    q('[data-sum-bags]').textContent=nb+' bag'+(nb>1?'s':'')+' · '+supplyText;
    const flavParts=DATA.flavors.filter(f=>state.counts[f.id]>0).map(f=>(f.emoji?f.emoji+' ':'')+f.label+(state.counts[f.id]>1?' ×'+state.counts[f.id]:''));
    q('[data-sum-flavors]').textContent=flavParts.length?flavParts.join(' + '):'Pick your flavors';
    const freeShip = nb>=DATA.freeShipQty;
      const shipTxt = freeShip?'Free shipping':'+'+DATA.shipText+' shipping';
    const fmS=effMonths();
    q('[data-sum-delivery]').textContent = isSub ? ('Every '+fmS+' month'+(fmS>1?'s':'')) : 'One-time';
      /* its own row now. <mark> so free shipping reads as the win it is,
         rather than as plain text sitting beside an amount. */
      const shipEl=q('[data-sum-shipping]');
      if(shipEl){
        if(freeShip){
          /* only the saving is highlighted. Marking the whole line put a yellow
             block across most of the row, which stops the highlight meaning
             anything: the amount is the part worth the eye landing on. */
          const lead = String(TXT.shipFree||'').trim();
          const won = String(TXT.shipSaved||'').replace('[amount]', DATA.shipText||'').trim();
          shipEl.innerHTML = (lead ? esc(lead)+' ' : '') + (won ? '<mark>'+esc(won)+'</mark>' : '');
        }
        else shipEl.textContent=DATA.shipText;
      }
    q('#wg-sub-'+sid).classList.toggle('sel',isSub);

    /* one-time: full variant prices, no discount; free ship only at threshold.
       Per-day figure = average bag price in the mix over servings. */
    const oneTotal=fullSum;
    q('[data-onetotal]').textContent=money(oneTotal)+(nb<DATA.freeShipQty?' + ship':'');
    q('[data-oneperday]').textContent=money(Math.round(fullSum/nb/DATA.servings))+'/day';

    q('#wg-sub-'+sid).style.opacity=state.plan==='sub'?'1':'.55';
    const subwrap=q('#wg-sub-'+sid).closest('.wg-subwrap');
    if(subwrap) subwrap.classList.toggle('dim',state.plan!=='sub');
    const subtopEl=q('#wg-sub-'+sid+' .wg-subtop');
    if(subtopEl) subtopEl.setAttribute('aria-pressed',isSub?'true':'false');
    q('#wg-onetime-'+sid).classList.toggle('active',state.plan==='onetime');
    q('#wg-onetime-'+sid).setAttribute('aria-pressed',state.plan==='onetime'?'true':'false');

    const cta=document.getElementById('wg-cta-'+sid);
    const total=state.plan==='sub'?subTotal:oneTotal;
    /* if subscribing, every chosen flavor must resolve a selling plan for the interval */
    const planGap = state.plan==='sub'
      ? DATA.flavors.filter(f=>state.counts[f.id]>0 && !planFor(f, effMonths()))
      : [];
    if(planGap.length){
      q('[data-foot-was]').style.display='none'; q('[data-foot-save]').style.display='none';
      q('[data-footamt]').textContent='Unavailable';
      cta.disabled=true; cta.textContent='Subscription unavailable';
      return;
    }
    if(got!==cap||cap===0){
      q('[data-foot-was]').style.display='none'; q('[data-foot-save]').style.display='none';
      q('[data-footamt]').textContent=money(total);
      cta.disabled=true; cta.textContent=got===0?(TXT.ctaEmpty||''):'Add '+(cap-got)+' more bag'+((cap-got)>1?'s':'');
    }else{
      const fullTot=fullSum;
      if(state.plan==='sub'&&fullTot>subTotal){
        q('[data-foot-was]').style.display=''; q('[data-foot-was]').textContent=money(fullTot);
        q('[data-foot-save]').style.display=''; q('[data-foot-save]').textContent='Save '+money(fullTot-subTotal);
      } else {
        q('[data-foot-was]').style.display='none'; q('[data-foot-save]').style.display='none';
      }
      q('[data-footamt]').textContent=money(total)+(DATA.isAU?' AUD':'');
      cta.disabled=false;
      cta.textContent=(state.plan==='sub'?(TXT.ctaSub||''):(TXT.ctaOnce||''))+' · '+money(total);

      /* Combined savings. shipText is display copy ("$8.80"), so the number is
         read out of it rather than stored twice; if it will not parse, the
         shipping half is dropped rather than guessed at. The price above keeps
         showing the discount alone, which is what the product is advertised at. */
      const shipCents = (function(){
        const n = parseFloat(String(DATA.shipText||'').replace(/[^0-9.]/g,''));
        return isFinite(n) && n > 0 ? Math.round(n*100) : 0;
      })();
      const discountSave = Math.max(0, fullTot - total);
      const shipSave = (DATA.freeShipQty > 0 && nb >= DATA.freeShipQty) ? shipCents : 0;
      const totalSave = discountSave + shipSave;
      const fillSave = function(tpl){
        var out = String(tpl||'').replace('[total]', money(totalSave)).replace('[ship]', DATA.shipText||'');
        /* the parenthetical is only true while they are not paying for shipping */
        if(!shipSave) out = out.replace(/\s*\([^)]*\)/,'');
        return out.trim();
      };
      [['[data-cta-savings]', TXT.ctaSavings], ['[data-cta-note]', TXT.ctaNote]].forEach(function(pair){
        const el=q(pair[0]);
        if(!el) return;
        /* only while shipping is actually free: without that, the line just
           restates the Save figure sitting directly above it */
        const copy = (shipSave>0 && totalSave>0) ? fillSave(pair[1]) : '';
        el.hidden = !copy;
        el.innerHTML = copy ? esc(copy).split(esc(money(totalSave))).join('<b>'+esc(money(totalSave))+'</b>') : '';
      });
    }
  }

  /* ---------- interactions ---------- */
  qa('#wg-house-'+sid+' button').forEach(b=>b.onclick=()=>{
    if(state.household===b.dataset.h) return; /* no-op tap must not disturb the rows */
    state.household=b.dataset.h;
    resizeRows();
    render();
  });
  qa('.wg-size').forEach(s=>s.onclick=()=>{
    if(state.months===+s.dataset.months) return; /* no-op tap must not disturb the rows */
    state.months=+s.dataset.months;
    resizeRows();
    render();
  });
  q('#wg-nudge-'+sid).onclick=()=>{if(state.months===2)return; state.months=2; resizeRows(); render();};

  /* ---------- step 3: one card per flavor with a stepper ----------
     state.rows is the ordered list of picks (flavor ids); counts derive from
     it. A cap change keeps the earliest picks and drops the rest. */
  const rowsWrap=document.getElementById('wg-frows-'+sid);
  function syncCounts(){
    DATA.flavors.forEach(f=>state.counts[f.id]=0);
    state.rows.forEach(id=>{ if(id&&state.counts[id]!=null) state.counts[id]++; });
  }
  function resizeRows(){
    const cap=capBags();
    if(state.rows.length>cap) state.rows=state.rows.slice(0,cap);
    syncCounts();
    if(!rowsWrap||!rowsWrap.querySelector('.wg-mcard')) buildRows();
    syncCards();
  }
  function buildRows(){
    if(!rowsWrap) return;
    rowsWrap.innerHTML=DATA.flavors.map(o=>{
      const img=o.image
        ?'<img class="wg-mcard__img" src="'+esc(o.image)+'" alt="" width="'+(o.imageW||600)+'" height="'+(o.imageH||600)+'" loading="lazy">'
        :'<span class="wg-mcard__img wg-mcard__img--none" aria-hidden="true">'+esc(o.emoji||'')+'</span>';
      return '<div class="wg-mcard'+(o.available?'':' oos')+'" data-mcard="'+esc(o.id)+'">'
        +(o.isNew?'<span class="wg-newtag">'+esc(TXT.newTag||'')+'</span>':'')
        +(o.available?'':'<span class="wg-mcard__oos">'+esc(DATA.soldOutText)+'</span>')
        +img
        +'<div class="wg-mcard__name">'+esc(o.label)+'</div>'
        +(o.badgeText?'<span class="wg-sugar wg-mcard__tag '+esc(o.badgeStyle||'free')+'">'+esc(o.badgeText)+'</span>':'')
        +'<div class="wg-mcard__qty">'
          +'<button type="button" data-mq="-1" data-flavor="'+esc(o.id)+'" aria-label="'+esc(String(TXT.mixMinus||'').replace('[flavor]',o.label))+'">−</button>'
          +'<span class="wg-mcard__n" data-mn>0</span>'
          +'<button type="button" data-mq="1" data-flavor="'+esc(o.id)+'" aria-label="'+esc(String(TXT.mixPlus||'').replace('[flavor]',o.label))+'">+</button>'
        +'</div>'
        +'</div>';
    }).join('');
    qa('#wg-frows-'+sid+' [data-mq]').forEach(b=>b.onclick=()=>{
      if(b.disabled) return;
      const id=b.dataset.flavor, f=flavorById(id);
      if(!f) return;
      if(+b.dataset.mq>0){
        if(!f.available||chosen()>=capBags()) return;
        state.rows.push(id);
        /* the nutrition and lab report popups follow the last flavor picked */
        state.pickedFlavor=id;
      }else{
        const at=state.rows.lastIndexOf(id);
        if(at===-1) return;
        state.rows.splice(at,1);
      }
      syncCounts();
      render();
    });
  }
  function syncCards(){
    const full=chosen()>=capBags();
    qa('#wg-frows-'+sid+' .wg-mcard').forEach(card=>{
      const id=card.dataset.mcard, f=flavorById(id), n=state.counts[id]||0;
      card.classList.toggle('has',n>0);
      card.querySelector('[data-mn]').textContent=n;
      card.querySelector('[data-mq="-1"]').disabled=n===0;
      card.querySelector('[data-mq="1"]').disabled=full||!(f&&f.available);
    });
  }

  /* keyboard: the selector cards are divs, so Enter/Space must activate them
     (links and real buttons inside keep their native behavior). Bound once
     per element: re-inits after an editor morph keep the same root node. */
  if(!root.__wgKeyBound){
    root.__wgKeyBound = true;
    root.addEventListener('keydown',(e)=>{
      if(e.key!=='Enter'&&e.key!==' ') return;
      if(e.target.closest('a,button,input,select,textarea')) return;
      const t=e.target.closest('.wg-size,.wg-fcard,.wg-sub,.wg-onetime,.wg-nudge');
      if(!t) return;
      e.preventDefault();
      t.click();
    });
  }

  q('#wg-sub-'+sid).onclick=()=>{state.plan='sub';render();};
  q('#wg-onetime-'+sid).onclick=()=>{state.plan='onetime';render();};

  /* gallery: native scroll-snap track (smooth swipe) + thumbnail sync */
  /* Measured on the live store: the slide is 345px on a 390px phone and
     596px on a 1440px desktop. Matching those lets the browser take a 600 or
     an 800 instead of the 1200 every device used to get. */
  const GALLERY_SIZES='(min-width: 990px) 43vw, 92vw';
  function gallerySet(f){ return (f.images&&f.images.length)?f.images:(f.image?[{full:f.image,thumb:f.image}]:[]); }
  let galleryIdx=0, scrollRaf=null;
  /* The slide a click or an arrow is currently scrolling to, while it is
     still travelling. The scroll listener below reads the nearest slide on
     every frame, so without this the active thumb steps through every slide
     the animation passes: click the fifth thumb from the first and the black
     border visibly runs along all five on its way there. The destination is
     already marked active by the click that started it, so every index in
     between is noise. */
  let scrollingTo=null, settleTimer=null;
  const track=document.getElementById('wg-gtrack-'+sid);

  function scrollToIdx(i){
    const slide=track.children[i];
    if(!slide) return;
    scrollingTo=i;
    track.scrollTo({left:slide.offsetLeft, behavior:'smooth'});
  }
  function setActiveThumb(i){
    galleryIdx=i;
    qa('#wg-thumbs-'+sid+' .wg-th').forEach((b,n)=>b.classList.toggle('active',n===i));
    const count=track.children.length;
    qa('[data-gnav]').forEach(b=>{
      b.disabled=+b.dataset.gnav<0 ? i<=0 : i>=count-1;
      b.style.display=count>1?'':'none';
    });
  }
  /* HTML-attribute escape for strings concatenated into innerHTML (labels
     can carry quotes via the product-title fallback) */
  const esc=s=>String(s==null?'':s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

  function buildGallery(f){
    if(!f) return;
    const set=gallerySet(f);
    /* The first slide is the one on screen the instant this runs, so it
       loads eagerly. Lazy, it was at the mercy of Chrome deciding when to
       check whether it was in view, and inside a flex scroll container that
       is being scrolled back to 0 in the same frame the check could land
       before layout settled and not run again until something scrolled. The
       symptom was a blank product photo after switching flavour that filled
       in, along with every other slide, the moment you swiped. It is also the
       largest image on the page, so it should never have been deferred. */
    track.innerHTML=set.map((im,i)=>'<div class="wg-gslide"><img src="'+esc(im.full)+'"'
      +(im.set?' srcset="'+esc(im.set)+'" sizes="'+GALLERY_SIZES+'"':'')
      +' alt="'+esc(f.label)+'" width="'+(im.w||1200)+'" height="'+(im.h||1200)+'" decoding="async"'
      +(i===0?' loading="eager" fetchpriority="high"':' loading="lazy"')+'></div>').join('');
    const wrap=document.getElementById('wg-thumbs-'+sid);
    /* Same reasoning, and these are tiny: the first few sit in view from the
       moment they exist, so deferring them buys nothing and risks the same
       blank strip. */
    wrap.innerHTML=set.map((im,i)=>'<button type="button" class="wg-th'+(i===0?' active':'')+'" data-i="'+i+'" aria-label="Image '+(i+1)+'"><img src="'+esc(im.thumb)+'" alt="" width="'+(im.tw||200)+'" height="'+(im.th||200)+'"'+(i<4?' loading="eager"':' loading="lazy"')+'></button>').join('');
    wrap.style.display=set.length>1?'flex':'none';
    qa('#wg-thumbs-'+sid+' .wg-th').forEach(b=>b.onclick=()=>{ setActiveThumb(+b.dataset.i); scrollToIdx(+b.dataset.i); });
    /* desktop arrows step one slide, clamped at the ends */
    qa('[data-gnav]').forEach(b=>b.onclick=()=>{
      const next=Math.max(0,Math.min(track.children.length-1,galleryIdx+(+b.dataset.gnav)));
      setActiveThumb(next); scrollToIdx(next);
    });
    /* reset to first slide without smooth-scroll animation (prevents the page jump) */
    scrollingTo=null;
    setActiveThumb(0);
    track.style.scrollBehavior='auto';
    track.scrollLeft=0;
    /* Then one real scroll, a pixel out and back. Belt and braces for the
       same iOS paint bug the CSS note above describes: assigning a value the
       track is already at is not a scroll and will not invalidate anything,
       and a swipe was the only thing bringing the new photos in. Costs one
       frame at one pixel, which nobody can see. Worth deleting once a phone
       confirms the CSS change alone is enough. */
    requestAnimationFrame(()=>{
      track.scrollLeft=1;
      requestAnimationFrame(()=>{ track.scrollLeft=0; track.style.scrollBehavior='smooth'; });
    });
  }
  /* keep the active thumb in sync as the user swipes; bound once per track
     element so an editor-morph re-init does not stack listeners */
  if(!track.__wgScrollBound){
    track.__wgScrollBound = true;
    track.addEventListener('scroll',()=>{
      if(scrollRaf) return;
      scrollRaf=requestAnimationFrame(()=>{
        scrollRaf=null;
        const i=Math.round(track.scrollLeft/track.clientWidth);
        /* A swipe can interrupt a programmatic scroll and never reach its
           target, which would park the thumbs for good. So the flag also
           lifts once the track has been still for a moment, wherever it
           actually ended up. */
        clearTimeout(settleTimer);
        settleTimer=setTimeout(()=>{
          scrollingTo=null;
          const at=Math.round(track.scrollLeft/track.clientWidth);
          if(at!==galleryIdx) setActiveThumb(at);
        },120);
        if(scrollingTo!=null){
          if(i===scrollingTo) scrollingTo=null;
          return;
        }
        if(i!==galleryIdx) setActiveThumb(i);
      });
    },{passive:true});
  }

  qa('#wg-fsel-'+sid+' .wg-fcard').forEach(t=>{
    /* button semantics applied here, not in Liquid: without JS the cards are
       inert imagery and must not be announced as pressable */
    t.setAttribute('role','button');
    t.tabIndex=0;
    t.setAttribute('aria-pressed', t.classList.contains('active')?'true':'false');
    if(t.dataset.flavorLabel) t.setAttribute('aria-label', t.dataset.flavorLabel);
    /* sold-out (real or front-end forced): dim the card and tag it; it stays
       clickable so shoppers can still browse the gallery */
    const fc=flavorById(t.dataset.flavor);
    if(fc&&!fc.available&&!t.querySelector('.wg-fcard-oos')){
      t.classList.add('oos');
      const tag=document.createElement('span');
      tag.className='wg-fcard-oos';
      tag.textContent=DATA.soldOutText;
      t.appendChild(tag);
    }
    t.onclick=()=>{
      const f=flavorById(t.dataset.flavor);
      if(!f) return; /* card without matching data must never poison state */
      const isSwitch=state.galleryFlavor!==f.id;
      state.galleryFlavor=f.id;
      state.pickedFlavor=f.id;
      qa('#wg-fsel-'+sid+' .wg-fcard').forEach(x=>{
        x.classList.toggle('active',x===t);
        x.setAttribute('aria-pressed',x===t?'true':'false');
      });
      buildGallery(f);
      render();
      if(isSwitch) trackFlavorView('select_item', f);
    };
  });
  buildGallery(flavorById(state.galleryFlavor));

  /* Warm the first slide of every other flavour once the browser has nothing
     better to do. Switching flavour was a cold download of a full size image
     while the page was still fetching a megabyte and a half of app scripts,
     which is why it could take seconds. Fetched through the same srcset the
     gallery will ask for, so the switch hits cache rather than the network.
     Low priority and after idle, so it cannot compete with the first paint.
     Two extra images on a three flavour store; delete this block if that
     trade ever stops being worth it. */
  const warmGalleries=()=>{
    try{
      DATA.flavors.forEach(f=>{
        if(!f||f.id===state.galleryFlavor) return;
        const set=gallerySet(f);
        if(!set.length||!set[0].full) return;
        const img=new Image();
        try{ img.fetchPriority='low'; }catch(e){}
        img.sizes=GALLERY_SIZES;
        if(set[0].set) img.srcset=set[0].set;
        img.src=set[0].full;
      });
    }catch(e){ /* warming is an optimisation; it must never break the page */ }
  };
  /* 1.2s at the latest. Idle on a page carrying this many app scripts can be
     a long time coming, and a shopper who switches flavour at three seconds
     needs the bytes to have been on their way since one. Low priority means
     this still yields to anything the page is doing. */
  if(typeof requestIdleCallback==='function') requestIdleCallback(warmGalleries,{timeout:1200});
  else setTimeout(warmGalleries,800);

  /* modal */
  qa('[data-wg-modal]').forEach(b=>b.onclick=(ev)=>{
    const kind=b.dataset.wgModal;
    /* guarantee: the link's page opens inside the modal as an iframe;
       without JS the anchor still navigates to the policy normally */
    if(kind==='guarantee'){
      /* honor open-in-new-tab gestures */
      if(ev&&(ev.metaKey||ev.ctrlKey||ev.shiftKey)) return;
      /* the subscription terms link sits INSIDE the subscribe card, whose own
         click selects the plan. an inline onclick cannot stop that here,
         because assigning .onclick above would have wiped it. */
      if(ev&&ev.stopPropagation) ev.stopPropagation();
      const href=b.getAttribute('href')||'';
      /* prefer the server-rendered policy text: clean copy, no framed page
         with header and footer; iframe only as the fallback. each link names
         its own template, defaulting to the guarantee's. */
      const tpl=q('['+(b.dataset.policyTpl||'data-guarantee-policy')+']');
      const policyHtml=tpl&&tpl.innerHTML&&tpl.innerHTML.replace(/\s/g,'')!==''?tpl.innerHTML:'';
      /* '#' is the placeholder the terms link carries when only a policy is
         picked, so it must not count as somewhere to send the shopper */
      const realHref=href&&href!=='#'?href:'';
      if(!policyHtml&&!realHref) return;
      if(ev&&ev.preventDefault) ev.preventDefault();
      const title=b.dataset.modalTitle||TXT.guarTitle||'';
      q('[data-modaltitle]').textContent=title;
      let gbody=policyHtml||'<iframe class="wg-modal-frame" src="'+esc(realHref)+'" title="'+esc(title)+'"></iframe>';
      if(realHref) gbody+='<p class="wg-modal-sub"><a href="'+esc(realHref)+'" target="_blank" rel="noopener">'+esc(b.textContent)+'</a></p>';
      q('[data-modalbody]').innerHTML=gbody;
      document.getElementById('wg-modal-'+sid).classList.add('show');
      return;
    }
    /* the popups show the flavor the shopper last picked, in a bag row or
       on the gallery cards, falling back to the flavor in the gallery */
    const f=flavorById(state.pickedFlavor)||flavorById(state.galleryFlavor);
    if(!f) return;
    /* Lab Report prefers the shared named lab-results popup (the transparency
       section's modal) when it is on the page, opened on the tab of the
       flavor being viewed; the image modal below is the fallback */
    if(kind==='lab'&&DATA.labModalName){
      const escName=window.CSS&&CSS.escape?CSS.escape(DATA.labModalName):DATA.labModalName;
      const dlg=document.querySelector('dialog[data-wg-modal-name="'+escName+'"]');
      if(dlg&&typeof dlg.showModal==='function'){
        /* find this flavor's tab: exact product handle first, then flavor
           name matching (a lab entry without a linked product keys its tab
           by flavor, e.g. "peach" inside "Wild Peach") */
        const tabs=Array.prototype.slice.call(dlg.querySelectorAll('[data-lab-tab]'));
        let tab=f.handle?tabs.find(t=>t.dataset.labKey===f.handle):null;
        if(!tab){
          const norm=s=>String(s||'').toLowerCase().trim();
          const fl=norm(f.label);
          tab=tabs.find(t=>{
            const k=norm(t.dataset.labKey), lbl=norm(t.textContent);
            return (k&&fl.indexOf(k)!==-1)||(lbl&&fl.indexOf(lbl)!==-1)||(lbl&&lbl.indexOf(fl)!==-1);
          });
        }
        /* select through the tabs component, never a synthetic click: a
           click inside another section makes the theme editor select and
           scroll to that section behind the popup */
        if(tab){
          const comp=tab.closest('wildgainz-lab-results');
          const idx=comp&&comp.tabs?comp.tabs.indexOf(tab):-1;
          if(comp&&typeof comp.select==='function'&&idx>-1) comp.select(idx); else tab.click();
        }
        /* the shared opener lifts the dialog out of its section and locks
           the page so nothing behind it can scroll; plain showModal is the
           fallback if that script has not loaded */
        if(window.WildgainzModal&&window.WildgainzModal.open) window.WildgainzModal.open(dlg); else dlg.showModal();
        return;
      }
    }
    if(kind==='nutrition'){
      /* flavor tabs across every flavor that has a nutrition image, opening
         on the flavor currently in the gallery */
      const withImg=DATA.flavors.filter(x=>x.nutritionImage);
      const cur=withImg.find(x=>x.id===f.id)||withImg[0];
      let body='';
      if(withImg.length>1){
        body+='<div class="wg-mtabs">'+withImg.map(x=>
          '<button type="button" class="wg-mtab'+(cur&&x.id===cur.id?' active':'')+'" aria-pressed="'+(cur&&x.id===cur.id?'true':'false')+'" data-mtab="'+esc(x.id)+'">'+(x.emoji?esc(x.emoji)+' ':'')+esc(x.label)+'</button>'
        ).join('')+'</div>';
      }
      body+=cur?'<img data-mimg src="'+esc(cur.nutritionImage)+'" alt="'+esc(cur.label+' · '+(TXT.btnNutrition||''))+'">':'<p>Coming soon.</p>';
      q('[data-modaltitle]').textContent=(cur?cur.label:f.label)+' · '+(TXT.btnNutrition||'');
      q('[data-modalbody]').innerHTML=body;
      qa('[data-mtab]').forEach(t=>t.onclick=()=>{
        const x=flavorById(t.dataset.mtab);
        if(!x||!x.nutritionImage) return;
        qa('[data-mtab]').forEach(o=>{
          o.classList.toggle('active',o===t);
          o.setAttribute('aria-pressed',o===t?'true':'false');
        });
        const img=q('[data-mimg]');
        if(img){ img.src=x.nutritionImage; img.alt=x.label+' · '+(TXT.btnNutrition||''); }
        q('[data-modaltitle]').textContent=x.label+' · '+(TXT.btnNutrition||'');
      });
      document.getElementById('wg-modal-'+sid).classList.add('show');
      return;
    }
    const src=f.labImage;
    q('[data-modaltitle]').textContent=f.label+' · '+(TXT.btnLab||'');
    q('[data-modalbody]').innerHTML=src?'<img src="'+esc(src)+'" alt="">':'<p>Coming soon.</p>';
    document.getElementById('wg-modal-'+sid).classList.add('show');
  });
  q('[data-modalclose]').onclick=()=>document.getElementById('wg-modal-'+sid).classList.remove('show');
  document.getElementById('wg-modal-'+sid).onclick=(e)=>{if(e.target.id==='wg-modal-'+sid)e.target.classList.remove('show');};

  /* ---------- tracking ----------
     Default mode pushes ONE dataLayer event per action with a unique
     event_id; the GTM web container and the Stape server container fan it
     out to GA4, Meta CAPI, and TikTok, deduping browser and server events
     on that id. Direct mode additionally fires gtag/fbq/ttq from the page
     for setups without a tag manager. */
  function eventId(){ return 'wg-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10); }
  function gaItemFor(f, priceCents, qty){
    return {item_id:String(f.variantId), item_name:f.label, item_variant:f.sku||undefined, price:+(priceCents/100).toFixed(2), quantity:qty||1};
  }
  /* true when a real GTM container runs; plain gtag.js also fills
     window.google_tag_manager with G-/AW- keys, so test for GTM- keys */
  function hasGtmContainer(){
    try{ return !!(window.google_tag_manager && Object.keys(window.google_tag_manager).some(k=>k.indexOf('GTM-')===0)); }catch(e){ return false; }
  }

  /* view_item on load, select_item on flavor switch: without these the
     second flavor's product never enters view-based retargeting audiences.
     Silent in the theme editor so preview renders never pollute analytics. */
  function trackFlavorView(evName, f){
    if(!f || DATA.designMode) return;
    const evId=eventId();
    const currency=DATA.currency||'USD';
    const value=+(f.priceCents/100).toFixed(2);
    const item=gaItemFor(f, f.priceCents, 1);
    try{
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({ecommerce:null});
      window.dataLayer.push({event:evName, event_id:evId, ecommerce:{currency, value, items:[item]}});
    }catch(e){}
    if(DATA.trackingMode==='direct'){
      try{ if(typeof gtag==='function' && !hasGtmContainer()) gtag('event', evName, {currency, value, items:[item]}); }catch(e){}
      try{ if(typeof fbq==='function') fbq('track','ViewContent',{content_type:'product', content_ids:[String(f.variantId)], value, currency},{eventID:evId}); }catch(e){}
      try{ if(window.ttq && typeof ttq.track==='function') ttq.track('ViewContent',{content_type:'product', contents:[{content_id:String(f.variantId), quantity:1, price:value}], value, currency},{event_id:evId}); }catch(e){}
    }
  }

  /* add_to_cart reads a snapshot captured at click time, never live state:
     the shopper can change the mix while the request is in flight, and
     pixels must report what was actually added. */
  function trackAddToCart(snap){
    if(DATA.designMode) return; /* editor clicks are not shopper events */
    const isSub = snap.isSub;
    const lines = snap.lines.map(l=>{
      /* checkout truth: in configured mode Bundler discounts the full-price
         allocation at checkout, so report the post-discount unit to pixels */
      const unitCents = l.plan
        ? (DATA.priceSource==='configured' ? Math.round(l.flavor.priceCents*(100-subPct(snap.totalQty))/100) : l.plan.priceCents)
        : l.flavor.priceCents;
      return {flavor:l.flavor, qty:l.qty, unitCents, planId:l.plan?l.plan.planId:null};
    });
    /* order value rounds once on the total, matching the displayed price and
       Bundler's checkout rounding; summing per-unit rounded prices can drift
       a cent (4 bags at 25% of 4499c: 134.96 vs the charged 134.97) */
    let valueCents;
    if(isSub && DATA.priceSource==='configured'){
      const fullSum=lines.reduce((t,l)=>t+l.flavor.priceCents*l.qty,0);
      valueCents=Math.round(fullSum*(100-subPct(snap.totalQty))/100);
    }else{
      valueCents=lines.reduce((t,l)=>t+l.unitCents*l.qty,0);
    }
    const value = +(valueCents/100).toFixed(2);
    const currency = DATA.currency || 'USD';
    const evId = eventId();
    const gaItems = lines.map(l=>gaItemFor(l.flavor, l.unitCents, l.qty));
    const payload = {currency, value, event_id: evId, purchase_type: isSub?'subscription':'one_time', delivery_interval_months: isSub?snap.months:null, items: gaItems};

    /* GTM (GA4 ecommerce schema); the Stape server container mirrors this
       to Meta CAPI etc. with the same event_id for dedup */
    try{
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ecommerce:null});
      window.dataLayer.push({event:'add_to_cart', event_id:evId, purchase_type:payload.purchase_type, ecommerce:{currency, value, items:gaItems}});
    }catch(e){}

    if(DATA.trackingMode==='direct'){
      /* gtag direct, ONLY when no GTM container runs: with GTM present the
         dataLayer push above already reaches GA4/Ads and a second gtag call
         would double-count. Note plain gtag.js also populates
         window.google_tag_manager (with G-/AW- keys), so the discriminator
         must be an actual GTM- container key, not the object's existence. */
      try{ if(typeof gtag==='function' && !hasGtmContainer()) gtag('event','add_to_cart',{currency, value, items:gaItems}); }catch(e){}
      /* Meta pixel; eventID lets CAPI dedupe against this browser event */
      try{ if(typeof fbq==='function') fbq('track','AddToCart',{content_type:'product', content_ids:lines.map(l=>String(l.flavor.variantId)), contents:lines.map(l=>({id:String(l.flavor.variantId), quantity:l.qty, item_price:+(l.unitCents/100).toFixed(2)})), value, currency},{eventID:evId}); }catch(e){}
      /* TikTok pixel */
      try{ if(window.ttq && typeof ttq.track==='function') ttq.track('AddToCart',{content_type:'product', contents:lines.map(l=>({content_id:String(l.flavor.variantId), quantity:l.qty, price:+(l.unitCents/100).toFixed(2)})), value, currency},{event_id:evId}); }catch(e){}
    }

    /* Shopify Web Pixels custom event (custom pixels can subscribe to this) */
    try{ if(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish==='function') Shopify.analytics.publish('wildgainz_add_to_cart', payload); }catch(e){}
    /* DOM hook for anything else */
    try{ document.dispatchEvent(new CustomEvent('wg:add_to_cart',{bubbles:true, detail:payload})); }catch(e){}
  }

  /* ---------- cart drawer ----------
     All cart reads/writes are guarded: any failure degrades to a fallback
     note with a link to the cart page, and never blocks purchasing. */
  let cartCache=null;
  const ourVariants={};
  DATA.flavors.forEach(f=>{ ourVariants[String(f.variantId)]=f; });

  async function fetchCart(){
    try{
      const r=await fetch('/cart.js',{cache:'no-store'});
      if(!r.ok) throw new Error('cart '+r.status);
      cartCache=await r.json();
    }catch(e){ cartCache=null; }
    return cartCache;
  }

  function updateBubble(sections){
    try{
      const html=sections&&sections['cart-icon-bubble'];
      const bubble=document.getElementById('cart-icon-bubble');
      if(html&&bubble){
        const parsed=new DOMParser().parseFromString(html,'text/html').querySelector('.shopify-section');
        if(parsed) bubble.innerHTML=parsed.innerHTML;
      }
    }catch(e){}
  }

  function cartStats(cart){
    let subBags=0, otpBags=0, subFull=0, otpFull=0;
    /* collected, not summed: the tier is not known until every bag is counted */
    const subUnits=[];
    (cart&&cart.items||[]).forEach(it=>{
      const flavor=ourVariants[String(it.variant_id)];
      if(!flavor) return;
      /* configured mode discounts must base on the variant FULL price from
         our own data: a cart line's price can already carry a selling-plan
         allocation discount, and stacking the tier on top of that would
         double-discount the display */
      const baseUnit=DATA.priceSource==='configured'?flavor.priceCents:(it.original_price!=null?it.original_price:it.price);
      const full=baseUnit*it.quantity;
      if(it.selling_plan_allocation){ subBags+=it.quantity; subFull+=full; subUnits.push({unit:baseUnit, qty:it.quantity}); }
      else{ otpBags+=it.quantity; otpFull+=full; }
    });
    let ourCartPrice=0, otpSwitchIf=0;
    (cart&&cart.items||[]).forEach(it=>{
      const fl=ourVariants[String(it.variant_id)];
      if(!fl) return;
      ourCartPrice+=(it.final_line_price!=null?it.final_line_price:it.line_price);
      if(!it.selling_plan_allocation){
        const pl=planFor(fl, state.months);
        otpSwitchIf+=(pl?pl.priceCents:fl.priceCents)*it.quantity;
      }
    });
    const subPay=subUnits.reduce((n,l)=>n+discountedUnit(l.unit, subBags)*l.qty, 0);
    return {subBags, otpBags, subFull, otpFull, ourCartPrice, otpSwitchIf, subPay, allBags:subBags+otpBags, allFull:subFull+otpFull};
  }

  /* One bag at the tier, rounded down. Per bag and not per order, and down
     and not to nearest, both for the reasons and against the two live
     checkouts set out at discountedUnit() in
     component-wildgainz-cart-drawer.js. The two files have to agree to the
     cent: this price and the drawer's are the same promise made twice, and a
     shopper sees them within one tap of each other. This one is always a
     projection, since the order it prices has no cart yet. */
  function discountedUnit(unitCents, bags){
    if(DATA.priceSource!=='configured') return unitCents; /* Loop: allocations already truthful */
    return Math.floor(unitCents*(100-subPct(bags))/100);
  }

  /* Offers and the delivery interval belong to the drawer now, which reads
     the same tiers from theme settings: assets/component-wildgainz-cart-drawer.js */

  const drawerEl=document.querySelector('cart-drawer[data-wg-cart]');
  const dq=(sel)=>drawerEl?drawerEl.querySelector(sel):null;
  const dqa=(sel)=>drawerEl?Array.prototype.slice.call(drawerEl.querySelectorAll(sel)):[];
  /* The shell (open, close, scroll lock, focus trap, header icon) belongs to
     the layout element; this section only renders the body. Rendering from
     the cache we already hold paints instantly, and the shell reconciles
     with the server behind it: every mutation is line-key addressed, so a
     vanished line 404s and the next render corrects the display. */
  async function openDrawer(){
    if(!drawerEl||typeof drawerEl.open!=='function') return;
    await drawerEl.open(document.activeElement);
  }
  function closeDrawer(){ if(drawerEl&&drawerEl.close) drawerEl.close(); }

  /* The drawer renders itself; see assets/component-wildgainz-cart-drawer.js. */

  /* begin_checkout with the event id its GA and Meta pair share. Takes the
     settled cart when the drawer hands one over, else our own cache. */
  function fireBeginCheckout(c){ try{
    const src=c||cartCache;
    if(src&&!DATA.designMode){
      const st=cartStats(src);
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({ecommerce:null});
      window.dataLayer.push({event:'begin_checkout', event_id:eventId(), ecommerce:{currency:DATA.currency||'USD', value:+(((st.subPay+st.otpFull))/100).toFixed(2)}});
    }
  }catch(e){} }

  /* drawer chrome: bound every init with idempotent onclick assignments, no
     once-guard, so an editor morph that keeps the wrapper but replaces the
     buttons still gets working close and checkout */
  if(drawerEl){
    /* The drawer renders itself from theme settings so every page gets the
       same cart. All we add is our nicer flavor names and emoji. The
       deferred drawer script may not have run yet, so park them too. */
    window.WildgainzCartFlavors=DATA.flavors;
    if(window.WildgainzCart&&window.WildgainzCart.setFlavors) window.WildgainzCart.setFlavors(DATA.flavors);
    const co=dq('[data-drawer-checkout]');
    if(co) co.onclick=()=>{
      /* The drawer waits for its own writes to land before it leaves, so the
         checkout shows the cart the shopper was just looking at. Without it
         (script not yet run) leave the old way. */
      const api=window.WildgainzCart;
      if(api&&api.checkout){ api.checkout(fireBeginCheckout); return; }
      fireBeginCheckout(); setTimeout(()=>{ window.location.href='/checkout'; },250);
    };
  }

  /* The header cart icon is bound by the drawer element in the layout.
     Binding it here too was what opened Dawn's cart and this one at once. */

  /* prefetch the cart so the smart after-add decision and the drawer have a
     warm cache from the start */
  fetchCart();

  /* ---------- add to cart (AJAX, native selling_plan: Seal or Loop) ---------- */
  document.getElementById('wg-cta-'+sid).onclick=async ()=>{
    /* snapshot the order at click time; tracking reads this, never live state */
    const isSub=state.plan==='sub';
    /* The plan the cart as a whole will be on once this order is in it,
       rather than this order's supply size read on its own. A bag added onto
       an existing subscription of a different size was going on one plan and
       being moved to another a moment later; this puts it where it is going
       in the first place, one write sooner. Same end state. Falls back to the
       chosen size when the drawer is not on the page or does not match
       cadence to bags. */
    let addMonths=effMonths();
    if(isSub){
      const cartApi=window.WildgainzCart;
      if(cartApi&&cartApi.plannedMonths){ try{ addMonths=cartApi.plannedMonths(chosen(), mult())||effMonths(); }catch(e){} }
    }
    const items=[], lines=[];
    DATA.flavors.forEach(f=>{
      if(state.counts[f.id]>0){
        const plan=isSub?(planFor(f, addMonths)||planFor(f, effMonths())):null;
        if(isSub&&!plan) return; /* validated in render; belt-and-braces */
        const item={id:f.variantId, quantity:state.counts[f.id]};
        if(plan) item.selling_plan=plan.planId;
        items.push(item);
        lines.push({flavor:f, qty:state.counts[f.id], plan});
      }
    });
    if(!items.length) return;
    const snap={isSub, months:effMonths(), totalQty:lines.reduce((t,l)=>t+l.qty,0), lines};
    const cta=document.getElementById('wg-cta-'+sid);
    cta.disabled=true; cta.textContent='Adding…'; cta.classList.add('loading');
    /* When the drawer is always the destination, open it on the press rather
       than after the round trip. It was waiting for /cart/add.js to come back
       first, so a four second add was four seconds of nothing happening after
       a tap. The drawer paints the cart it already holds, and the new line
       arrives when the request does. Not done for smart mode, which cannot
       know whether it is opening the drawer until the add has landed. */
    /* The rows being added are handed to the drawer first, whatever happens
       next: it draws them settling rather than "your cart is empty" with
       live add tiles for the length of the round trip, and it counts the
       add as pending work, so a Checkout pressed in the drawer meanwhile
       waits for it. */
    try{ if(window.WildgainzCart&&window.WildgainzCart.expect) window.WildgainzCart.expect(snap.lines.map(l=>({variantId:l.flavor.variantId, quantity:l.qty, planId:l.plan?l.plan.planId:null, planName:l.plan?l.plan.planName:''}))); }catch(e){}
    if((DATA.afterAdd||'smart')==='drawer') openDrawer();
    try{
      /* the sections param makes Shopify return the re-rendered header cart
         bubble in the same response, Dawn's own update mechanism */
      /* A stalled request used to spin forever: the loading class comes off
         only when this settles or the catch runs, and a hung fetch does
         neither. On a phone changing cell that is a dead button, so cap it
         and let the shopper try again. */
      const ctl = ('AbortController' in window) ? new AbortController() : null;
      let timedOut = false;
      /* 30s, not 15. A saturated connection is the common case here, not a
         hung request: five review videos can be streaming while somebody
         reads, and one of them is large. Fifteen seconds of a busy desktop
         connection is not a failure, it is a queue. */
      const killer = setTimeout(()=>{ timedOut = true; if(ctl) ctl.abort(); }, 30000);
      let res;
      try{
        res = await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items, sections:'cart-icon-bubble'}), signal: ctl?ctl.signal:undefined});
      }catch(netErr){
        /* Aborting a POST does not un-send it. The server may well have added
           the items already, so telling the shopper it failed invites them to
           press again and buy twice. Ask the cart what actually happened
           before saying anything. */
        let landed=false;
        try{
          const check=await fetch('/cart.js',{headers:{Accept:'application/json'},cache:'no-store'});
          if(check.ok){
            const c=await check.json();
            landed=items.every(it=>(c.items||[]).some(line=>
              line.variant_id===it.id
              && line.quantity>=it.quantity
              && String((line.selling_plan_allocation&&line.selling_plan_allocation.selling_plan&&line.selling_plan_allocation.selling_plan.id)||'')===String(it.selling_plan||'')));
            if(landed){ cartCache=c; res={ok:true, json:async()=>({sections:null})}; }
          }
        }catch(e){}
        if(!landed) throw new Error(timedOut ? 'Taking too long, please try again' : 'Network error, please try again');
      }finally{
        clearTimeout(killer);
      }
      cta.classList.remove('loading');
      if(!res.ok){
        /* 429 is Shopify throttling the storefront cart, and it answers with
           an HTML error page rather than the JSON this code was parsing, so
           the shopper got the word "cart" and no idea what to do. It throttles
           progressively, slowing writes before it starts refusing them, which
           is what a very slow add that still returns 200 looks like. Almost
           nobody shopping will see it; anyone testing the buy box will. */
        if(res.status===429){ throw new Error('Too many tries just now, wait a moment and press again'); }
        let msg='cart';
        try{ const eb=await res.json(); if(eb&&typeof eb.description==='string'&&eb.description) msg=eb.description; }catch(e){}
        throw new Error(msg);
      }
      try{ trackAddToCart(snap); }catch(e){}
      try{
        const body=await res.json();
        updateBubble(body&&body.sections);
      }catch(e){}
      document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
      /* Was there anything in the cart before this add? null when the
         prefetch never landed, which counts as "assume there was". Read
         before the merge below overwrites it. */
      const wasEmpty = cartCache ? (cartCache.item_count||0)===0 : null;
      /* merge this add into the cached cart LOCALLY: the drawer decision and
         first paint then need NO extra round trip. openDrawer reconciles
         with the server in the background; brand-new merged lines carry a
         pending key whose steppers stay disabled until then. */
      if(cartCache){
        const c=JSON.parse(JSON.stringify(cartCache));
        snap.lines.forEach(l=>{
          const pid=l.plan?l.plan.planId:null;
          const hit=(c.items||[]).find(x=>x.variant_id===l.flavor.variantId&&(((x.selling_plan_allocation&&x.selling_plan_allocation.selling_plan&&x.selling_plan_allocation.selling_plan.id)||null)===pid));
          if(hit){
            hit.quantity+=l.qty;
            const unit=hit.original_price!=null?hit.original_price:hit.price;
            hit.line_price=unit*hit.quantity; hit.original_line_price=unit*hit.quantity; hit.final_line_price=unit*hit.quantity;
          }else{
            c.items=c.items||[];
            c.items.push({key:'pending-'+l.flavor.variantId+'-'+(pid||'0'), variant_id:l.flavor.variantId, product_title:l.flavor.label, quantity:l.qty, image:l.flavor.image, price:l.flavor.priceCents, original_price:l.flavor.priceCents, line_price:l.flavor.priceCents*l.qty, original_line_price:l.flavor.priceCents*l.qty, final_line_price:l.flavor.priceCents*l.qty, selling_plan_allocation:pid?{selling_plan:{id:pid, name:(l.plan&&l.plan.planName)||''}}:null});
          }
        });
        c.item_count=(c.item_count||0)+snap.totalQty;
        c.total_price=(c.total_price||0)+snap.lines.reduce((t,l)=>t+l.flavor.priceCents*l.qty,0);
        cartCache=c;
      }
      const mode = DATA.afterAdd||'smart';
      const goto = (u)=>setTimeout(()=>{ window.location.href=u; },300); /* let pixels flush */
      /* The drawer owns the cart from here: it re-reads it, learns how many
         people the bags are for (a couple on a one month supply holds two
         bags and wants them monthly), and brings a cart built from two
         different sizes onto one delivery cadence. Awaited before any
         navigation, so the checkout receives that cart and not the one in
         between. */
      const api=window.WildgainzCart;
      /* An empty cart plus this add is a cart holding only what we just sent,
         on the plan we just chose for it: nothing to read back, nothing to
         move. On the way out of the page that is a round trip the shopper
         was waiting through for no answer. */
      const settled = (mode==='checkout'||mode==='cart') && wasEmpty===true;
      if(api&&api.noteAdd){ try{
        if(settled) api.noteAdd({household:mult(), settled:true});
        else await api.noteAdd({household:mult()});
      }catch(e){} }
      if(mode==='checkout'){
        if(settled){ fireBeginCheckout(cartCache); goto('/checkout'); }
        else if(api&&api.checkout) api.checkout(fireBeginCheckout);
        else goto('/checkout');
      }
      else if(mode==='cart'){ goto('/cart'); }
      else if(mode==='drawer'){ openDrawer(); cta.textContent='Added ✓'; setTimeout(render,1500); }
      else{
        /* smart: drawer when an offer applies, when the cart already held
           items (over-purchase guard), or when the cart state is UNKNOWN
           (fail open to the drawer, never silently past a possible dupe).
           The offer is computed against the cart as it is after this add:
           asked against the drawer's own copy it was the pre-add cart, and
           a first add never saw its upsell. */
        const offer = (api && api.computeOffer) ? api.computeOffer((api.cart&&api.cart())||cartCache) : null;
        const held = cartCache ? (cartCache.item_count - snap.totalQty) > 0 : null;
        if(held===null || held || offer){ openDrawer(); cta.textContent='Added ✓'; setTimeout(render,1500); }
        else if(api&&api.checkout) api.checkout(fireBeginCheckout);
        else goto('/checkout');
      }
    }catch(err){
      cta.classList.remove('loading');
      cta.textContent=(err&&err.message&&err.message!=='cart')?err.message:'Something went wrong';
      /* nothing was added: take the settling rows back out of the drawer */
      try{ if(window.WildgainzCart&&window.WildgainzCart.expect) window.WildgainzCart.expect([]); }catch(e){}
      setTimeout(render,2500);
    }
  };

  resizeRows();
  render();
  /* sentinel for the health watcher: rows exist from here on, so their
     disappearance while connected means the editor wiped the DOM */
  root.__wgHasRows = true;
  trackFlavorView('view_item', flavorById(state.galleryFlavor));

  /* Escape closes the modal. Guarded on window (survives re-renders) keyed by
     section id, so the document listener is added once and never stacks. */
  window.__wgEscBound = window.__wgEscBound || {};
  if(!window.__wgEscBound[sid]){
    window.__wgEscBound[sid] = 1;
    document.addEventListener('keydown',(e)=>{
      if(e.key!=='Escape') return;
      const m=document.getElementById('wg-modal-'+sid);
      if(m) m.classList.remove('show');
      const dr=document.querySelector('#wg-buybox-'+sid+' [data-drawer]');
      if(dr) dr.classList.remove('open');
    });
  }
  } /* end initBuyboxInner() */

  /* Define the element once. Every <wildgainz-buybox> already in the page and
     every one the theme editor injects later upgrades automatically and fires
     connectedCallback, so the box can never be left blank after an edit. */
  if(!window.customElements) { /* very old browser: init any present instances */
    document.querySelectorAll('wildgainz-buybox').forEach(initBuybox);
  } else if(!customElements.get('wildgainz-buybox')){
    customElements.define('wildgainz-buybox', class extends HTMLElement {
      connectedCallback(){ initBuybox(this); }
    });
  }
})();
